import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TopActors({ actors }) {
  const navigate = useNavigate();
  const displayActors = actors && actors.length > 0 ? actors.slice(0, 6) : [1, 2, 3, 4, 5, 6];

  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    show: { opacity: 1, scale: 1, transition: { duration: 0.4, ease: "easeOut" } }
  };

  return (
    <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 mt-3 mb-3">
      <div className="flex justify-between items-center mb-3 md:mb-6 px-1 sm:px-0">
        <h2 className="text-sm sm:text-base md:text-xl font-bold text-gray-900 border-l-4 border-[#3b82f6] pl-2.5 whitespace-nowrap">
          Top Actors / Actresses
        </h2>
        
        {/* Desktop View All Pill */}
        <button 
          onClick={() => navigate('/shows')}
          className="hidden sm:flex text-gray-500 hover:text-gray-800 text-xs font-medium border border-gray-200 px-4 py-1.5 rounded-full items-center bg-white shadow-xs hover:bg-gray-50 transition-colors shrink-0"
        >
          View All &rarr;
        </button>

        {/* Mobile Arrow Button Only */}
        <button 
          onClick={() => navigate('/shows')}
          className="flex sm:hidden w-7 h-7 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 hover:text-blue-600 hover:border-blue-300 transition-colors shadow-xs shrink-0 ml-2"
          aria-label="View All Artists"
        >
          <ArrowRight size={14} />
        </button>
      </div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        className="flex justify-between items-center overflow-x-auto pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
      >
        {displayActors.map((actor, index) => (
          <motion.div variants={itemVariants} key={index} className="flex flex-col items-center mx-1.5 sm:mx-2 min-w-[70px] sm:min-w-[85px]">
            <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-full border border-gray-100 overflow-hidden shadow-xs mb-2 bg-gray-100 flex items-center justify-center">
              <img 
                src={actor.image ? (actor.image.startsWith('http') || actor.image.startsWith('/') ? actor.image : '/' + actor.image) : 'https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png'} 
                alt={actor.name || 'Actor'} 
                className="w-full h-full object-cover" 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png';
                }}
              />
            </div>
            <span className="text-[10px] sm:text-xs font-medium text-gray-800 text-center line-clamp-1">{actor.name || (index === 0 ? 'Piyush' : 'Smita Panda')}</span>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
